// hooks/useCategories.ts
import { useCallback, useEffect, useState } from "react";
import { getAllCategories_V2 } from "../Services_V2/Category.service";
import { CategoryType, SelectOption } from "../types";
import { showError } from "../utils/error";

export const useCategories = () => {
    const [options, setOptions] = useState<SelectOption[]>([]);
    const [map, setMap] = useState<Map<string, string>>(new Map());
    const [loading, setLoading] = useState(true);

    const fetch = useCallback(async () => {
        try {
            setLoading(true);
            const res = await getAllCategories_V2();
            const cats: CategoryType[] = res?.data ?? [];

            const opts = cats.map(({ _id, name }) => ({ label: name, value: _id }));
            const nameMap = new Map<string, string>();
            cats.forEach(c => nameMap.set(c._id, c.name));

            setOptions(opts);
            setMap(nameMap);
        } catch (error) {
            showError(error);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetch();
    }, [fetch]);

    return { options, map, loading, refetch: fetch };
};